import log from 'loglevel';

log.setDefaultLevel(log.levels.DEBUG);
class Log {
  debug(...args: any[]): void {
    log.debug(...args);
  }

  info(...args: any[]): void {
    log.info(...args);
  }

  warn(...args: any[]): void {
    log.warn(...args);
  }

  error(...args: any[]): void {
    log.error(...args);
  }
}

export default new Log();
